import AdFunction from '@/models/ad-schedules/AdFunction'

export default {
  adFunctions: [],
  adFunction: new AdFunction(),
  isLoading: true,
}
